// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"157":"3756a9fe","163":"a8b4ccb5","229":"63db61c9","511":"eba88030","791":"2abe6163"}[chunkId] + ".chunk.js";
};